module.exports = __webpack_public_path__ + "static/media/assessments.06465bc6.svg";